export const KEY_EMSL_SUMMARY_COUNT = "KEY_EMSL_SUMMARY_COUNT";
export const KEY_EMSL_SUMMARY_ENGAGED_BRAND_EXPOSURE =
  "KEY_EMSL_SUMMARY_ENGAGED_BRAND_EXPOSURE";
export const KEY_EMSL_SUMMARY_ENGAGED_UNIQUE_USERS =
  "KEY_EMSL_SUMMARY_ENGAGED_UNIQUE_USERS";
export const KEY_EMSL_SUMMARY_ENGAGED_USER_LIST =
  "KEY_EMSL_SUMMARY_ENGAGED_USER_LIST";

export const KEY_EMSL_SUMMARY_CONSENTED_BRAND_EXPOSURE =
  "KEY_EMSL_SUMMARY_CONSENTED_BRAND_EXPOSURE";
export const KEY_EMSL_SUMMARY_CONSENTED_UNIQUE_USERS =
  "KEY_EMSL_SUMMARY_CONSENTED_UNIQUE_USERS";
export const KEY_EMSL_SUMMARY_CONSENTED_HCP_DETAILS =
  "KEY_EMSL_SUMMARY_CONSENTED_HCP_DETAILS";

export const KEY_EMSL_SUMMARY_IN_DEMO_SCHEDULE_STATUS =
  "KEY_EMSL_SUMMARY_IN_DEMO_SCHEDULE_STATUS";
export const KEY_EMSL_SUMMARY_IN_DEMO_MEDIUM_DEMO =
  "KEY_EMSL_SUMMARY_IN_DEMO_MEDIUM_DEMO";
export const KEY_EMSL_SUMMARY_IN_DEMO_GEOGRAPHY =
  "KEY_EMSL_SUMMARY_IN_DEMO_GEOGRAPHY";
export const KEY_EMSL_SUMMARY_IN_DEMO_CALENDER =
  "KEY_EMSL_SUMMARY_IN_DEMO_CALENDER";
export const KEY_EMSL_SUMMARY_IN_DEMO_HCP_DETAILS =
  "KEY_EMSL_SUMMARY_IN_DEMO_HCP_DETAILS";

export const KEY_EMSL_SUMMARY_PRESCRIBERS_NPS_SCORE =
  "KEY_EMSL_SUMMARY_PRESCRIBERS_NPS_SCORE";
export const KEY_EMSL_SUMMARY_PRESCRIBERS_LBL_SENT =
  "KEY_EMSL_SUMMARY_PRESCRIBERS_LBL_SENT";
export const KEY_EMSL_SUMMARY_PRESCRIBERS_HCP_SCORE =
  "KEY_EMSL_SUMMARY_PRESCRIBERS_HCP_SCORE";
export const KEY_EMSL_SUMMARY_PRESCRIBERS_LBL_DOCUMENT =
  "KEY_EMSL_SUMMARY_PRESCRIBERS_LBL_DOCUMENT";

export const KEY_EMSL_SUMMARY_LEADS_USER_DETAILS =
  "KEY_EMSL_SUMMARY_LEADS_USER_DETAILS";
export const KEY_EMSL_SUMMARY_LEADS_USER_ENGAGEMENT =
  "KEY_EMSL_SUMMARY_LEADS_USER_ENGAGEMENT";
export const KEY_EMSL_SUMMARY_LEADS_USER_ENGAGEMENT_By_ID =
  "KEY_EMSL_SUMMARY_LEADS_USER_ENGAGEMENT_By_ID";

export const KEY_EMSL_PROJECT_DETAILS = "KEY_EMSL_PROJECT_DETAILS";

export const KEY_LEAD_DATA_FILE = "KEY_LEAD_DATA_FILE";

export const KEY_TEMPLATE_FETCH = "KEY_TEMPLATE_FETCH";
